module.exports = __webpack_public_path__ + "img/logo-maps.208bc876.jpg";